import { Col, Row, Form, Card } from "react-bootstrap";
import PropTypes from "prop-types";
import { ShowBoxData } from "./HeadDetail";
import PaginationComponent from "../PaginationComponent";
import { useEffect, useState } from "react";
import TableForm2s from "../TableFormScrb";

function DetailEquip({ data, columns, equipIndex, setEquipIndex, onChangeCallback, callbackImage, defaultTableData, isReport }) {
  const field = [
    {
      name: "Seq_No",
      label: "เลขที่ใบสั่งงาน",
      type: "text",
      disabled: true,
      size: "2_25"
    },
    {
      name: "Job_Type",
      label: "ประเภทงาน",
      type: "text",
      disabled: true,
      size: "2"
    },
    {
      name: "No",
      label: "ครั้งที่",
      type: "text",
      disabled: true,
      size: "1"
    },
    {
      name: "Sq",
      label: "sq.",
      type: "text",
      disabled: true,
      size: "1"
    },
    {
      name: "Item_Name",
      label: "ชื่อสินค้า",
      type: "text",
      disabled: true,
      size: 3
    },
    {
      name: "Project_No",
      label: "หมายเลขเครื่อง",
      type: "text",
      disabled: true,
      size: 2
    },
    {
      name: "Start",
      label: "วันที่เข้างาน",
      type: "date",
      disabled: true,
      size: "2_25"
    },
    {
      name: "Start",
      label: "เวลา",
      type: "time",
      disabled: true,
      size: "2"
    },
    {
      name: "End",
      label: "ถึงวันที่",
      type: "date",
      disabled: true,
      size: 2
    },
    {
      name: "End",
      label: "เวลา",
      type: "time",
      disabled: true,
      size: "1_5"
    },
    {
      name: "Ticket",
      label: "หมายเลข TicKet ลูกค้า",
      type: "text",
      disabled: true,
      size: "1_5"
    },
    {
      name: "Location",
      label: "ที่ตั้งเครื่องจักร",
      type: "text",
      disabled: true,
      size: 2
    },
  ]

  const dataShow = data[equipIndex]

  const [tableData, setTableData] = useState()

  useEffect(() => {
    setTableData({
      Standard: data[equipIndex]?.tableStandard || []
      // ?.map(el => (
      //   {
      //     ...el,
      //     ...defaultTableData?.tableStandard?.find(ele => ele.id == el.item_step_des_id),
      //   }
      // ))
      ,
      Check: data[equipIndex]?.tableCheck || [],
      Record: data[equipIndex]?.tableRecord || [],
      Special: dataShow ? data[equipIndex]?.tableSpecial || defaultTableData?.tableSpecial : []
    })
  }, [data, equipIndex])
  // console.log(dataShow)
  return (
    <div>
      {!isReport &&
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Body>
            <div className="pb-4 fs-2 text-center">
              รายละเอียดใบสั่งงานแยกตามสินค้าและหมายเลขเครื่อง
            </div>

            <Col as={Row} className="mb-3">
              <ShowBoxData
                field={field || []}
                data={dataShow}
                disableAll={true}
              />
            </Col>
          </Card.Body>

          <Pagination
            data={data}
            paginationProps={{
              rowsPerPage: 1,
              currentPage: equipIndex + 1,
              rowCount: data?.length,
              onChangePage: page => {
                setEquipIndex(page - 1)
              }
            }}
          />
        </Card>
      }

      <Form noValidate >
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
            <Card.Title className="mb-0 fs-2">
              ขั้นตอนการทำงานมาตรฐาน
            </Card.Title>
          </Card.Header>

          <Card.Body>
            <TableForm2s
              data={tableData?.Standard}
              // data={data[equipIndex]?.Standard || defaultTableData?.tableStandard}
              columns={columns.Standard}
              editForm
              pagination={false}
              onChangeCallback={newData => {
                setTableData({ ...tableData, Standard: newData })
                const clone = [...data]
                data[equipIndex].tableStandard = newData
                onChangeCallback(clone)
              }}
              minHeight='300px'
              callbackImage={callbackImage}
            // pendingFetch={loading}
            />
          </Card.Body>
        </Card>
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
            <Card.Title className="mb-0 fs-2">
              คำสั่ง ตรวจสอบ/เปลี่ยน sparepart
            </Card.Title>
          </Card.Header>

          <Card.Body>
            <TableForm2s
              data={tableData?.Check}
              columns={columns.Check}
              editForm
              pagination={false}
              isEditIndex
              onChangeCallback={(newData, i, e) => {
                const use_ = newData.find((e, i) => i == e.isEdit)?.use
                const newDatas = newData.map(el => (
                  { ...el, use: use_, isEdit: true }
                ))
                setTableData({ ...tableData, Check: newDatas })
                const clone = [...data]
                data[equipIndex].tableCheck = newDatas
                onChangeCallback(clone)
              }}
              minHeight='300px'
              callbackImage={callbackImage}
            />
          </Card.Body>
        </Card>
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
            <Card.Title className="mb-0 fs-2">
              คำสั่งการบันทึกข้อมูล
            </Card.Title>
          </Card.Header>

          <Card.Body>
            <TableForm2s
              data={tableData?.Record}
              columns={columns.Record}
              editForm
              pagination={false}
              onChangeCallback={newData => {
                setTableData({ ...tableData, Record: newData })
                const clone = [...data]
                data[equipIndex].tableRecord = newData
                onChangeCallback(clone)
              }}
              callbackImage={callbackImage}
            />
          </Card.Body>
        </Card>
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
            <Card.Title className="mb-0 fs-2">
              คำสั่งพิเศษ
            </Card.Title>
          </Card.Header>

          <Card.Body>
            <TableForm2s
              data={tableData?.Special}
              columns={columns.Special}
              editForm={false}
              pagination={false}
            // onChangeCallback={newData => {
            //   setTableData({ ...tableData, Special: newData })
            //   const clone = data
            //   data[equipIndex].tableSpecial = newData
            //   onChangeCallback(clone)
            // }}
            />
          </Card.Body>
        </Card>
      </Form>

    </div>
  )
}
DetailEquip.propTypes = {
  data: PropTypes.object,
  columns: PropTypes.object,
  equipIndex: PropTypes.num,
  setEquipIndex: PropTypes.func,
  onChangeCallback: PropTypes.func,
  callbackImage: PropTypes.func,
  defaultTableData: PropTypes.object,
  isReport: PropTypes.bool
};

const Pagination = ({ data, paginationProps }) => {
  const {
    rowsPerPage,
    rowCount,
    currentPage,
    onChangePage,
  } = paginationProps;

  return (
    !!data?.length &&
    <nav className="rdt_Pagination mt-2 d-flex flex-column flex-md-row justify-content-center align-items-center">

      <PaginationComponent
        data={new Array(rowCount)}
        currentPage={Number(currentPage)}
        itemsPerPage={Number(rowsPerPage)}
        onPageChange={(page) => page != currentPage && onChangePage(page)}
        scrollToTop={false}
      />
    </nav>
  );
};

Pagination.propTypes = {
  data: PropTypes.array,
  paginationProps: PropTypes.object,
};


export { DetailEquip, Pagination }